// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"Scrollbar_scrollbar_3Czam","scrollbar-outer":"Scrollbar_scrollbar-outer_1o8Rs","scrollbar-wrapper":"Scrollbar_scrollbar-wrapper_2MEi-"};